import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Range } from '../../../../features/card-editor/components/range/range';
import { usePhotoControls } from '../../../../features/card-editor/hooks/use-photo-controls';
import { getScaleFromSlider } from '../../../../utils/get-scale-from-slider';
import { getSliderFromScale } from '../../../../utils/get-slider-from-scale';
import { HeaderContentProps } from '../scale-drawer-types';
import styles from '../scale-drawer.module.scss';
import { RangeVariants } from '../../../../features/card-editor/components/range/range-types';
import { Text } from '@dotcom/crown-ui';

export const HeaderContent = ({
  onChangeCallback,
  minScale,
  scaleAtCenter,
  sliderCenter,
  mode,
}: HeaderContentProps): React.ReactElement => {
  const { scaleSelectedPhoto, getCurrentPhotoScale } = usePhotoControls();
  const [scaleValue, setScaleValue] = useState(() =>
    getSliderFromScale({
      scale: getCurrentPhotoScale(),
      minScale,
      sliderMax: 200,
      maxScale: 200,
      scaleAtCenter,
      sliderCenter,
      mode,
    }),
  );
  const { register } = useForm({
    defaultValues: { ScaleRange: scaleValue },
  });
  const rangeName = 'ScaleRange';
  const { t } = useTranslation();

  const handleRangeChange = (sliderValue: number) => {
    const scale = getScaleFromSlider({
      sliderValue,
      minScale,
      sliderMax: 200,
      maxScale: 200,
      scaleAtCenter,
      sliderCenter,
      mode,
    });
    scaleSelectedPhoto(scale);
    setScaleValue(sliderValue);
    onChangeCallback && onChangeCallback(scale);
  };

  return (
    <div className={styles['header-wrapper']}>
      <div className={styles['scale-label']}>
        <Text as="span" color="textSecondary">
          {t('scaleDrawer.out')}
        </Text>
        <Text as="span" color="textSecondary" className={styles['value']}>
          {getScaleFromSlider({
            sliderValue: scaleValue,
            minScale,
            sliderMax: 200,
            maxScale: 200,
            scaleAtCenter,
            sliderCenter,
            mode,
          }).toFixed(0)}
        </Text>
        <Text as="span" color="textSecondary">
          {t('scaleDrawer.in')}
        </Text>
      </div>
      <Range
        testId="scale-range"
        domId={'scale'}
        label={'Scale'}
        min={0}
        max={200}
        step={1}
        tickCount={0}
        onChange={handleRangeChange}
        register={register(rangeName)}
        variant={RangeVariants.Primary}
      />
    </div>
  );
};
